import { useEffect, useState } from 'react'

import { useAccount } from 'wagmi'
import { backendApi } from 'utils/backend-api'

import useContracts from 'hooks/mint/useContracts'
import { useNftsInWalletByCollection } from 'hooks/nfts/useNftsInWallet'

import { DEFAULT_CHAIN_ID } from 'config'

export type GobblerInfo = {
  revealed: boolean
  owner: string
  assignedGobblerId: string
  gobblerTokenId: string
  name: string
  image: string
}

// TODO: john pls can you help me make
// a performant query for mi familia
function useOwnedGobblers(showUnrevealed = false): [GobblerInfo[], boolean] {
  const [loading, setLoading] = useState(true)
  const chainId = DEFAULT_CHAIN_ID
  const [gobblers, setGobblers] = useState<GobblerInfo[]>([])

  const [gobblerContract] = useContracts(chainId)
  const { address } = useAccount()
  const { data: gobblersOwnedByUser } = useNftsInWalletByCollection(
    address,
    gobblerContract?.address,
    chainId,
  )

  useEffect(() => {
    if (!gobblersOwnedByUser || !gobblerContract) {
      return
    }
    const rawGobblers = gobblersOwnedByUser.ownedNfts
    const gobblerIds = rawGobblers.map((gobbler) => parseInt(gobbler.id.tokenId).toString())

    const promises = gobblerIds.map(async (gobblerTokenId) => {
      const [owned, assignedIdx] = await gobblerContract?.getGobblerData(gobblerTokenId)

      const info = await backendApi.getGobblerMetadata(parseInt(assignedIdx.toString()))

      return {
        ...info,
        owner: address,
        assignedGobblerId: assignedIdx.toString(),
        gobblerTokenId: gobblerTokenId,
      }
    })

    Promise.all(promises).then((allGobblers) => {
      let gobblersToShow = allGobblers
      if (!showUnrevealed) {
        gobblersToShow = allGobblers.filter((gobbler) => gobbler.revealed)
      }

      setGobblers(gobblersToShow as GobblerInfo[])
      setLoading(false)
    })
  }, [address, gobblerContract, gobblersOwnedByUser, showUnrevealed])

  return [gobblers, loading]
}

export default useOwnedGobblers
